const Vue = require('vue');

Vue.component('score', {
    template: require('../../../../../../../components/templates/ui/score.pug'),
    props: {
        value: Number
    }
});
